/**
 * API hatasından kullanıcıya gösterilecek mesajı çıkarır.
 *
 * Laravel doğrulama hatalarını (422) şu biçimde döndürüyor:
 *   { message: "TC Kimlik No 11 haneli olmalıdır.",
 *     errors: { tc_no: ["TC Kimlik No 11 haneli olmalıdır."], ... } }
 *
 * `message` yalnızca İLK hatayı içerir. Birden fazla alan hatalıysa
 * kullanıcı tek tek düzeltip tekrar denemek zorunda kalır; bu yüzden
 * `errors` varsa hepsi birleştirilir.
 *
 * Eskiden çağrı noktalarının bir kısmı `error.response?.data?.message`
 * okuyordu, bir kısmı ise hatayı hiç açmadan sabit bir metin yazıyordu
 * ("Güncelleme başarısız") — ikinci gruptaki kullanıcı hatanın sebebini
 * hiç göremiyordu.
 *
 * @param {unknown} error   axios hatası
 * @param {string}  fallback Sunucudan anlamlı bir mesaj gelmezse gösterilecek metin
 */
export const apiErrorMessage = (error, fallback = 'İşlem başarısız.') => {
  const data = error?.response?.data;

  if (data?.errors && typeof data.errors === 'object') {
    const messages = Object.values(data.errors).flat().filter(Boolean);
    if (messages.length) return messages.join(' ');
  }

  if (typeof data?.message === 'string' && data.message.trim()) {
    return data.message;
  }

  // Ağ kesintisi / sunucuya hiç ulaşılamadı: response yok.
  if (error && !error.response) {
    return 'Sunucuya ulaşılamadı. İnternet bağlantınızı kontrol edin.';
  }

  return fallback;
};

export default apiErrorMessage;
